import { AdminConsoleAccessGuard, AdminPageContainer, AdminSectionCard } from "../../components/admin-console/admin-console-shell";
import { PageStoreProvider } from "./constructor-documents-page.lib";
import { ConstructorDocumentsTabs } from "./local-components/constructor-documents-tabs";
import { ConstructorDocumentsTable } from "./local-components/constructor-documents-table";
import { ConstructorDocumentsToolbar } from "./local-components/constructor-documents-toolbar";
import { NewDocumentKitModal } from "./local-components/new-document-kit-modal";

/** ЛК администратора услуг — «Конструктор — Документы» (комплекты документов). */
const ConstructorDocumentsPage = () => (
  <AdminConsoleAccessGuard>
    <PageStoreProvider>
      <NewDocumentKitModal />
      <AdminPageContainer>
        <AdminSectionCard
          title="Конструктор"
          subtitle="Настройка услуг портала, их бизнес-процессов по дорогам и комплектов документов для заявителей"
        >
          <ConstructorDocumentsTabs />
          <ConstructorDocumentsToolbar />
          <ConstructorDocumentsTable />
        </AdminSectionCard>
      </AdminPageContainer>
    </PageStoreProvider>
  </AdminConsoleAccessGuard>
);

export default ConstructorDocumentsPage;
